import { fetchVouchersAction } from "../../../../Actions/LogicActions/Voucher/FetchVouchersAction";
import { removedVoucherCodeAction } from "../../../../Actions/LogicActions/Voucher/RemoveVoucherCodeAction";
import { validateVoucherCodeAction } from "../../../../Actions/LogicActions/Voucher/ValidateVoucherCodeAction";
import { voucherOnChangeAction } from "../../../../Actions/UIActions/Checkout/Vocuher/VoucherOnChangeAction";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { evtTree } from "../../../../Orchestrator/ConstantTree";
import { IFetchVouchersActionParams, IRemovedVoucherCodeActionParams, IValidateVoucherCodeActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { IVoucherApplyEventParams } from "../../../../Orchestrator/Types/Interface/EventParams/VoucherAction";
import { VoucherContext } from "../Context/VoucherContext";
import { applyPromoCodeAction } from "../../../../Actions/LogicActions/PromoCode/ApplyPromoCodeAction";
import { removePromoCodeAction } from "../../../../Actions/LogicActions/PromoCode/RemovePromoCodeAction";
import { IPromoCodeEventParams } from "../../../../Orchestrator/Types/Interface/EventParams/PromoCodeAction";

class VoucherInitStep extends StepFlow {
    get stepName() { return "VoucherInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IVoucherApplyEventParams, void>({
                eventName: evtTree.Checkout.Voucher.Apply.Click,
                handler: async ({ data }) => {
                    let context = this.getCtx<VoucherContext>("voucherContext")!
                    if (context) {
                        context.bookingId = data?.bookingId || "";
                        const params: IValidateVoucherCodeActionParams = {
                            billingAmount: data?.billingAmount || 0,
                            bookingId: data?.bookingId || "",
                            voucherCode: data?.code || ""
                        }
                        await validateVoucherCodeAction.setParams(params)
                        await validateVoucherCodeAction.execute()

                        if (validateVoucherCodeAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                            const data = validateVoucherCodeAction.result!
                            if (data === "success") {
                                context.voucherCode = ""
                            }
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: evtTree.Checkout.Voucher.Input.onChange,
                handler: async ({ data }) => {
                    await voucherOnChangeAction.setParams(data || "")
                    await voucherOnChangeAction.execute()
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<number, void>({
                eventName: evtTree.Checkout.Voucher.Get,
                handler: async ({ data }) => {
                    const params: IFetchVouchersActionParams = {
                        userId: data || 0
                    }
                    fetchVouchersAction.setParams(params)
                    await fetchVouchersAction.execute()
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: evtTree.Checkout.Voucher.Remove.Click,
                handler: async ({ data }) => {
                    let context = this.getCtx<VoucherContext>("voucherContext")!
                    if (context) {
                        const params: IRemovedVoucherCodeActionParams = {
                            bookingId: context.bookingId,
                            voucherCode: data || ""
                        }
                        await removedVoucherCodeAction.setParams(params);
                        await removedVoucherCodeAction.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IPromoCodeEventParams, void>({
                eventName: evtTree.Checkout.PromoCode.Apply.Click,
                handler: async ({ data }) => {
                    applyPromoCodeAction.setParams({
                        bookingId: data?.bookingId || "",
                        promoCode: data?.code || ""
                    })
                    await applyPromoCodeAction.execute()
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IPromoCodeEventParams, void>({
                eventName: evtTree.Checkout.PromoCode.Remove.Click,
                handler: async ({ data }) => {
                    removePromoCodeAction.setParams({
                        bookingId: data?.bookingId || "",
                        promoCode: data?.code || ""
                    })
                    await removePromoCodeAction.execute()
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        this.setCtx("voucherContext", VoucherContext)
        console.log("Voucher Initial Step Executed.....");
    }
}

export const VoucherInitStepDeclaration = new StepDefinition({
    stepName: "VoucherInit_Step",
    stepClass: VoucherInitStep
});